import { render, staticRenderFns } from "./UpdateRequestFooter.vue?vue&type=template&id=485dafaa&scoped=true&"
import script from "./UpdateRequestFooter.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485dafaa",
  null
  
)

export default component.exports